import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import { IPicker, IPickersRes } from "./types";
import { IColumn } from "../../components/Table/types";
import CustomTable from "../../components/Table";
import { ChangeEvent, ReactElement, useState } from "react";
import { AxiosResponse } from "axios";
import { getApi, putApiWithAuth } from "../../utils/apis";
import getAPIUrl from "../../config";
import Header from "../Header";
import { useTranslation } from "react-i18next";
import MoreIcon from "../../assets/more.svg";
import { UserStatuses } from "../../utils/constants";
import styles from "./styles";
import TableHeader from "../../components/TableHeader";
import tableStyles from "../../components/Table/styles";
import { useNavigate } from "react-router-dom";
import { MenuItems } from "../../components/Menu/types";
import { SimpleMenu } from "../../components/Menu";
import EditIcon from "../../assets/pen-square.svg";
import TerminateIcon from "../../assets/calendar-clock.svg";
import toastStyles from "../../components/Toast/styles";
import Toast from "../../components/Toast";
import { getApiErrorMessage, getUserRole } from "../../utils/commonHelpers";
import FilterDrawer from "./FilterDrawer";
import ApprovalDrawer from "./ApprovalDrawer";

const getPickerList = async (
  page: number,
  search?: string,
  sortBy?: keyof IPicker,
  sortOrder?: "asc" | "desc" | string,
  filters?: {
    locationId: string;
    userId: string;
    status: string;
  }
): Promise<Error | IPickersRes> => {
  let url = `api/v1/pickup-locations?pageIndex=${page}&pageSize=10&sortBy=${sortBy ?? "createdAt"
    }&sortOrder=${sortOrder ?? "desc"}`;

  if (search) {
    url = `${url}&search=${search}`;
  }

  if (filters?.locationId) {
    url = `${url}&locationId=${filters.locationId}`;
  }

  if (filters?.userId) {
    url = `${url}&userId=${filters.userId}`;
  }


  if (filters?.status) {
    url = `${url}&status=${filters.status}`;
  }
  try {
    const resultData: AxiosResponse<IPickersRes> = await getApi(
      `${getAPIUrl()}/${url}`
    );
    return resultData.data;
  } catch (error) {
    return error as Error;
  }
};

const Pickers = () => {
  const [page, setPage] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("");
  const [fetchAgain, setFetchAgain] = useState(false);
  const [errorToast, setErrorToast] = useState<boolean>(false);
  const [toastErrorMsg, setErrorToastMsg] = useState<string>("");
  const [successToast, setSuccessToast] = useState<boolean>(false);
  const [toastSuccessMsg, setSuccessToastMsg] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [rowId, setRowId] = useState<string>("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [approvalDrawerOpen, setApprovalDrawerOpen] = useState(false);
const [selectedRow, setSelectedRow] = useState<IPicker | null>(null);
  const [filters, setFilters] = useState({
    locationId: "",
    userId: "",
    buildingName: "",
    floorNumber: "",
    identificationNumber: "",
    status: ""
  });

  const handleClose = () => {
    setRowId("");
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>, id: string) => {
    setRowId(id);
    setAnchorEl(event.currentTarget);
  };
  const handleOpenApprovalDrawer = (row: IPicker) => {
  setSelectedRow(row);
  setApprovalDrawerOpen(true);
};

const handleCloseApprovalDrawer = () => {
  setApprovalDrawerOpen(false);
  setSelectedRow(null);
};
const toggleApprovalDrawer = (open: boolean) => () => {
  setApprovalDrawerOpen(open);
};


const handleApprovalSubmit = async (approval: boolean) => {
  setLoading(true);
  const id = selectedRow?.locationId;
  if (!id) {
    setLoading(false);
    return;
  }
  try {
    const res = await putApiWithAuth(`${getAPIUrl()}/api/v1/locations/${id}/approval`, {
      automaticApproval: approval
    });

    setSuccessToastMsg(res.data.message);
    setSuccessToast(true);
    setSelectedRow(null);
    handleCloseApprovalDrawer();
    setTimeout(() => {
      setLoading(false);
      setFetchAgain(!fetchAgain);
      navigate("/pickers");
    }, 1000);
  } catch (error) {
    if (error instanceof Error) {
      const errorMsg = getApiErrorMessage(error);
      setErrorToastMsg(errorMsg);
      setErrorToast(true);
      setLoading(false);
    }
  }
};



  const { t } = useTranslation();
  const navigate = useNavigate();

  const userRole = getUserRole();

  const handleEditAction = (id: string) => {
    navigate(`/edit-picker/${id}`);
  };

  // Toggle Drawer
  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  const columns: IColumn<IPicker>[] = [
    {
      dataKey: "locationId",
      title: "Location",
      render: ({ row }: { row: IPicker }) => {
        return (
          <Typography sx={tableStyles.tableBodyCellText}>
            {row.location.name}
          </Typography>
        );
      },
      sortable: true,
    },
    {
      dataKey: "userId",
      title: "Picker",
      render: ({ row }: { row: IPicker }) => {
        return (
          <Typography
            sx={tableStyles.tableBodyCellText}
          >{`${row.user.firstName} ${row.user.lastName}`}</Typography>
        );
      },
      sortable: true,
    },
    { dataKey: "buildingName", title: "Building Name", sortable: true },
    { dataKey: "floorNumber", title: "Floor Number", sortable: true },
    {
      dataKey: "identificationNumber",
      title: "Identification Number",
      sortable: true,
    },
   {
  dataKey: "locationId",
  title: "Approval",
  render: ({ row }: { row: IPicker }) => {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography sx={tableStyles.tableBodyCellText}>
          {row.location.automaticApproval === true ? "Yes" : "No"}
        </Typography>
        <IconButton
          onClick={() => handleOpenApprovalDrawer(row)}
          size="small"
          sx={{ p: 0.5 }} // smaller padding
        >
          <img
            src={EditIcon}
            alt="edit"
            style={{ width: 16, height: 16 }}
          />
        </IconButton>
      </Box>
    );
  },
  sortable: false,
},
    {
      dataKey: "status",
      title: "Status",
      sortable: true,

      render: ({ row }: { row: IPicker }) => {
        const status = UserStatuses.find(
          (statusObj) => statusObj.name === row.status
        );
        if (status) {
          return (
            <Typography
              component="span"
              sx={{
                color: status.color,
                fontWeight: 500,
                lineHeight: "1.125rem",
                fontSize: "0.75rem",
              }}
            >
              {status.name}
            </Typography>
          );
        } else {
          return null;
        }
      },
    },

    {
      dataKey: "id",
      title: "Actions",
      sortable: false,
      render: ({ row }: { row: IPicker }): ReactElement => {
        const actionItems: MenuItems[] = [
          {
            item: (
              <Grid sx={styles.actionItemGrid}>
                <img alt="edit-icon" src={EditIcon} style={styles.actionIcon} />
                <Typography sx={styles.actionText("#1B1C1B")}>
                   {t("editData")}
                </Typography>
              </Grid>
            ),
            handleClick:
              userRole !== "Picker"
                ? () => handleEditAction(row.id)
                : undefined,
          },
          {
            item: (
              <Grid sx={styles.actionItemGrid}>
                <img
                  alt="terminate-icon"
                  src={TerminateIcon}
                  style={styles.actionIcon}
                />
                <Typography sx={styles.actionText("#EF4444")}>
                  {t("terminate")}
                </Typography>
              </Grid>
            ),
          },
        ];
        return (
          <Box key={row.id}>
            <IconButton key={row.id} onClick={(e) => handleClick(e, row.id)}>
              {<img alt="more" src={MoreIcon} style={styles.actionIcon} />}
            </IconButton>
            {rowId === row.id && (
              <SimpleMenu
                id={row.id}
                anchorEl={anchorEl}
                handleCloseMenu={handleClose}
                menuItems={actionItems}
              />
            )}
          </Box>
        );
      },
    },
  ];

  const handleSearchChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const val = event.target.value;
    setSearchValue(val);
    setPage(1);
    setFetchAgain(!fetchAgain);
  };

  const handleClearSearch = async () => {
    setSearchValue("");
    setPage(1);
    setFetchAgain(!fetchAgain);
  };
  const handleAdd = async () => {
    navigate("/add-picker");
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header
        name={t("pickers")}
        setErrorToast={setErrorToast}
        setSuccessToast={setSuccessToast}
        setErrorToastMsg={setErrorToastMsg}
        setSuccessToastMsg={setSuccessToastMsg}
      />
      <Box sx={styles.tableContainer}>
        <TableHeader
          headerTitle={t("picker")}
          headerDesc={t("picker")}
          handleClearSearch={handleClearSearch}
          handleSearchChange={handleSearchChange}
          buttonName={t("addPicker")}
          searchValue={searchValue}
          handleAdd={handleAdd}
          disableAdd={userRole === "Picker"}
          onFilterClick={toggleDrawer(true)}
        />

        <FilterDrawer
          drawerOpen={drawerOpen}
          toggleDrawer={toggleDrawer}
          handleApplyFilters={(filters) => {
            setFilters(filters);
            setPage(1);
            setFetchAgain(!fetchAgain);
          }}
        />
        <ApprovalDrawer
          drawerOpen={approvalDrawerOpen}
          toggleDrawer={toggleApprovalDrawer}
           onSubmit={handleApprovalSubmit}
        />

        <CustomTable
          page={page}
          setPage={setPage}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          fetchAgain={fetchAgain}
          setErrorToast={setErrorToast}
          setErrorToastMsg={setErrorToastMsg}
          columns={columns}
          rowKey="id"
          initialSortField={"createdAt"}
          fetchTableData={(page, search, sortField, sortDirection) =>
            getPickerList(page, search, sortField, sortDirection, filters)
          }
          loading={loading}
        />
      </Box>
      <Toast
        id="get-pickers-error"
        open={errorToast}
        message={toastErrorMsg}
        severity="error"
        onClose={() => setErrorToast(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        alertStyles={toastStyles.toastText}
      />
    </Box>
  );
};

export default Pickers;
